import { ParentChildRelationshipType } from 'we-tree-api-client/v2';
import { getParentChildLabel } from '@/i18n/labelMaps';

export { getParentChildLabel };

export type ParentChildRelationshipTypeValue =
  (typeof ParentChildRelationshipType)[keyof typeof ParentChildRelationshipType];

export const PARENT_CHILD_RELATIONSHIP_OPTIONS: { value: ParentChildRelationshipTypeValue; label: string }[] = (
  Object.values(ParentChildRelationshipType) as ParentChildRelationshipTypeValue[]
).map((value) => ({
  value,
  get label() {
    return getParentChildLabel(value);
  }
}));
